import { render, staticRenderFns } from "./ManageRecipients.vue?vue&type=template&id=0ab64975&"
import script from "./ManageRecipients.vue?vue&type=script&lang=js&"
export * from "./ManageRecipients.vue?vue&type=script&lang=js&"
import style0 from "./ManageRecipients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports